import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { SuccessComponent } from 'src/app/components/shared/components/success/success.component';
import { IUser, IUserData } from '../interfaces/user.interface';
import { LogService } from './log.service';
import { SocketService } from './socket.service';
import { EnvService } from 'src/app/services/env.service';
import { ICase } from 'src/app/modules/cases/interfaces/case.interface';

@Injectable({
  providedIn: 'root',
})
@Injectable()
export class UserService {
  readonly baseUrl = `${this.env.URL_API_V1}/user`;

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly socketService: SocketService,
    private readonly dialog: MatDialog,
    private readonly logService: LogService,
    private env: EnvService
  ) {
    if (!this.loginSocket && this.currentUser) {
      this.socketService.socket.emit('login', { user: this.currentUser._id });
    }
  }

  currentUser: IUser = null;
  isRas: boolean = false;
  isFrd: boolean = false;
  loginSocket: boolean = false;

  // hasUnits(): boolean {
  //   return this.currentUser && this.currentUser.role && this.currentUser.role.units && this.currentUser.role.units.length > 0;
  // }

  hasUnits(): boolean {
    console.log('Checking currentUser:', this.currentUser);
    if (!this.currentUser) {
      console.log('No currentUser');
      return false;
    }

    console.log('Checking currentUser.role:', this.currentUser.role);
    if (!this.currentUser.role) {
      console.log('No currentUser.role');
      return false;
    }

    console.log(
      'Checking currentUser.role.units:',
      this.currentUser.role.units
    );
    if (!this.currentUser.role.units) {
      console.log('No currentUser.role.units');
      return false;
    }

    console.log(
      'Checking currentUser.role.units.length:',
      this.currentUser.role.units.length
    );
    if (this.currentUser.role.units.length === 0) {
      console.log('currentUser.role.units is empty');
      return false;
    }

    console.log('User has units:', this.currentUser.role.units);
    return true;
  }

  get permissions() {
    return this.currentUser?.role;
  }

  async getCurrent() {
    this.getUserById(this.currentUser._id).subscribe((res: any) => {
      this.currentUser = res;
      this.currentUser.role.units = this.filtersUnitsCurrentUser(
        this.currentUser.role.units
      );
    });
  }
  async isUserAvailable() {
    return await new Promise((resolve) => {
      const token = sessionStorage.getItem('token');
      if (!token) {
        resolve(false);
        return;
      }
      if (this.currentUser != null) {
        resolve(true);
        return;
      }
      let url = `${this.baseUrl}/auth/${Date.now()}`;
      this.http
        .get<IUser>(url, {
          headers: new HttpHeaders({
            'access-token': token,
          }),
        })
        .subscribe({
          next: (res) => {
            this.socketService.socket.emit('login', { user: res._id });
            this.loginSocket = true;
            this.currentUser = res;
            let ras = this.currentUser.role.units.find(
              (element) => element.code == 'LDC'
            );
            let FRD = this.currentUser.role.units.find(
              (element) => element.code == 'ALT'
            );
            if (FRD) {
              this.isFrd = true;
            }
            if (ras && this.currentUser.role.units.length == 1)
              this.isRas = true;
            if (this.isRas) {
              this.router.navigate(['/resumeRas']);
            }
            this.currentUser.role.units = this.filtersUnitsCurrentUser(
              this.currentUser.role.units
            );
            resolve(true);
          },
          error: (err) => {
            resolve(false);
          },
        });
    });
  }

  async doLogout(inactivity = false) {
    this.logOut(this.currentUser._id).subscribe((m) => {
      console.log(m);
    });
    //realiza la solicitud de que hizo logout
    await this.logService
      .updateLogout(this.currentUser.idLog, inactivity, this.currentUser._id)
      .subscribe((r) => {
        console.log('log updated');
      });
    sessionStorage.clear();
    this.currentUser = null;
    this.isRas = false;
    this.router.navigate(['/login']);
  }

  getAll() {
    return this.http.get<IUser[]>(`${this.baseUrl}/getAll`);
  }

  getUserById(id) {
    return this.http.get<IUser[]>(`${this.baseUrl}/get/${id}`);
  }

  create(data) {
    data.user_creator = this.currentUser._id;
    return this.http.post<IUser>(`${this.baseUrl}/create`, data);
  }

  update(id, data) {
    data.user_creator = this.currentUser._id;
    return this.http.put<IUser>(`${this.baseUrl}/update/${id}`, data);
  }

  updateData(id, data) {
    data.user_creator = this.currentUser._id;
    return this.http.put<IUserData>(`${this.baseUrl}/data/${id}`, data);
  }

  updateCurrentUser(data) {
    data.user_creator = this.currentUser._id;
    this.http
      .put<IUser>(`${this.baseUrl}/update/${this.currentUser._id}`, data)
      .subscribe({
        next: (user) => {
          // PUT /update no puebla role.units (filtrarlas sobre ObjectIds las
          // vaciaba hasta el F5) y devuelve el hash: se conserva el role ya
          // poblado y no se guarda password en memoria.
          const { password, ...resto } = user as IUser & { password?: string };
          this.currentUser = { ...resto, role: this.currentUser.role };
          this.dialog.open(SuccessComponent, {
            data: { title: 'Usuario actualizado con éxito' },
          });
        },
      });
  }
  filtersUnitsCurrentUser(units) {
    return (units = units.filter((unit) => {
      return unit.deleted == false;
    }));
  }
  delete(id) {
    return this.http.delete<IUser>(
      `${this.baseUrl}/delete/${id}/${this.currentUser._id}`
    );
  }

  getUserData(id) {
    return this.http.get<IUserData>(`${this.baseUrl}/data/${id}`);
  }

  isUserBlocked(id) {
    return this.http.get<boolean>(`${this.baseUrl}/blocked/${id}`);
  }

  unlockUser(id) {
    return this.http.put<IUser>(`${this.baseUrl}/unlock/${id}`, {
      user: this.currentUser._id,
    });
  }

  getUsersByRole(id) {
    return this.http.get<IUser[]>(`${this.baseUrl}/byRole/${id}`);
  }

  getUsersByUnityAndPermission(id) {
    return this.http.get<IUser[]>(
      `${this.baseUrl}/getUsersByUnityAndPermission/${id}`
    );
  }
  updatePassword(body) {
    return this.http.put(`${this.baseUrl}/password`, body);
  }
  updatePasswordAfterAsk(body) {
    return this.http.put(`${this.baseUrl}/afterAsk`, body);
  }
  updateAsk(body) {
    return this.http.put(`${this.baseUrl}/ask`, body);
  }
  getUserAsk(username) {
    return this.http.get(`${this.baseUrl}/getAsk/${username}`);
  }

  getUsersConected() {
    return this.http.get(`${this.baseUrl}/usersConected`);
  }
  logOut(id) {
    return this.http.get(`${this.baseUrl}/logOut/${id}`);
  }
  findUsersByRoleCasetype(id) {
    return this.http.get(`${this.baseUrl}/findUsersByRoleCasetype/${id}`);
  }
  isGerente() {
    const nameRole = this.currentUser?.role?.name;
    return nameRole?.toLocaleUpperCase()?.includes('GERENTE') ?? false;
  }
}
